import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3.5, 3.5, 5.875, 3.5),

    '& > .MuiGrid-item': {
      marginBottom: theme.spacing(2.5),
    },
  },
  feeContainer: {
    marginBottom: theme.spacing(1),
  },
  recycleIcon: {
    width: theme.spacing(13),
    height: theme.spacing(11),
  },
  infoBlockContainer: {
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2, 3),
    width: `calc(50% - ${theme.spacing(0.5)}px)`,
  },
  actions: {
    marginTop: theme.spacing(6.25),
  },
  fee: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    borderBottom: `${theme.spacing(0.125)}px solid ${theme.palette.gray.main}`,
    paddingBottom: theme.spacing(1),
    width: '100%',
  },
  feeTitle: {
    ...theme.typography.h5,
    color: theme.palette.gray.light,
    marginBottom: theme.spacing(1),
  },
  feeValue: {
    color: theme.palette.primary.light,
  },
}));
